export const LEARN_MORE = 'https://docs.prebid.org/overview/analytics.html#analytics-adapters'
